import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Dapp from './components/Dapp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Dapp />
  </React.StrictMode>
);
